<template>
  <div class="pad-cycle-lookup">
    <div class="mb-10 bold-font">Pad Cycle Lookup</div>
    <el-form ref="form" :model="form" label-width="80px" size="small">
      <el-form-item :label="$t('text.date')">
        <el-date-picker
          v-model="form.date"
          type="datetime"
          :placeholder="$t('text.please_select')"
          class="wp-100"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Bounds (h)">
        <el-input-number
          v-model="form.bounds"
          :min="1"
          class="wp-100"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('text.utc_offset')">
        <el-select
          class="utc-select wp-100"
          v-model="form.utcOffset"
          size="small"
          :placeholder="$t('text.please_select')"
          filterable
        >
          <el-option
            v-for="item in utcOffsetOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Condition">
        <el-select
          v-model="form.condition"
          :placeholder="$t('text.please_select')"
          class="wp-100"
        >
          <el-option
            v-for="item in conditionOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-button
        class="save-btn min-w-80 mini-btn float-right"
        @click="searchData"
        :loading="loading"
        >Search</el-button
      >
    </el-form>
  </div>
</template>

<script>
import swal from 'sweetalert'
import moment from 'moment-timezone'
import { utcOffsets } from '@/const'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      form: this.$store.state.pods.padCycleLookUp,
      utcOffsetOptions: utcOffsets,
      conditionOptions: [
        {
          value: 1,
          label: 'Nearest Cycle'
        },
        {
          value: 2,
          label: 'Pad Leaked'
        },
        {
          value: 3,
          label: 'Low wetness pad with Red Status'
        },
        {
          value: 4,
          label: 'High wetness (full) pad with Green Status'
        }
      ],
      loading: false
    }
  },
  watch: {
    form: {
      handler() {
        this.$store.commit('pods/SET_PAD_CYCLE_LOOKUP', this.form)
      },
      deep: true
    },
    '$store.state.pods.selectedUtcOffset'() {
      this.form.utcOffset = this.$store.state.pods.selectedUtcOffset
    }
  },
  mounted() {
    if (!this.form.utcOffset) {
      this.form.utcOffset = this.$store.state.pods.selectedUtcOffset
    }
  },
  methods: {
    validateForm() {
      if (!this.form.date) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Warning',
          text: 'Please select date'
        })
        return false
      }
      if (!this.form.bounds) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Warning',
          text: 'Please enter bounds'
        })
        return false
      }
      if (!this.form.utcOffset) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Warning',
          text: 'Please select utc offset'
        })
        return false
      }
      if (!this.form.condition) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Warning',
          text: 'Please select condition'
        })
        return false
      }
      return true
    },
    searchData() {
      if (this.validateForm()) {
        if (!this.$store.state.pods.selectedPod.podId) return false
        this.loading = true
        ApiService.GetPadCycleData(
          this.$store.state.pods.selectedPod.podId,
          moment.tz(this.form.utcOffset).utcOffset() / 60,
          moment(this.form.date).format('YYYY-MM-DD HH:mm:ss'),
          this.form.condition,
          this.form.bounds
        )
          .then(response => {
            this.loading = false
            if (response.data.success) {
              let responseData = response.data.data
              // if no data, the api will return start time and end time as '0001-01-01T00:00:00'
              if (
                !responseData.startTime.includes('0001-01-01') &&
                !responseData.endTime.includes('0001-01-01')
              ) {
                this.$store.commit('pods/SET_SELECTED_DATE', [
                  moment(responseData.startTime, 'YYYY-MM-DDTHH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:s'
                  ),
                  moment(responseData.endTime, 'YYYY-MM-DDTHH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:s'
                  )
                ])
                this.$store.commit(
                  'pods/SET_SELECTED_DATE_QUICK_ACTION',
                  'custom'
                )
                this.$store.commit(
                  'pods/SET_SELECTED_UTC_OFFSET',
                  this.form.utcOffset
                )
              } else {
                swal({
                  icon: 'warning',
                  timer: 2000,
                  title: 'No data was obtained'
                })
              }
            } else {
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed'),
                text: response.data.msg
              })
            }
          })
          .catch(() => {
            this.loading = false
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed')
            })
          })
      }
    }
  }
}
</script>

<style lang="scss">
.pad-cycle-lookup {
  position: absolute;
  margin-top: 50px;
  border-top: 1px solid #d7d7d7;
  padding-top: 10px;

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    width: 280px;
  }

  .el-range-editor--small .el-range-separator {
    width: 20px;
  }
}
</style>
